/* eslint-disable no-debugger */
/* cspell: disable*/
import React from 'react';
import { Theme } from '@theme';
import { WithCoreProps, TranslationProps, CoreHelper } from 'ff-shared-components-core';
import {
	Button,
	TitleContainer,
	InputField,
	RadioButton,
	FileField,
	FileUploadType,
	SelectField,
	FileAction,
	TemporaryFile,
	BuildOkInfoModal,
	modalOpen,
	Modal,
	TitleContainer2,
	FieldsFormContainer,
	PageScreen,
} from '@shared/components';
import { entityDataSchema, isPrivateNipc as checkIfIsPrivateNipc } from '@components';
import './entityData.less';
import { FormikValues, Formik, Form, Field } from 'formik';
import {
	StoreState,
	RegisterInputData,
	getRegisterPharmacyInputData,
	saveTransferInputData,
	fetchUploadFileExecutionRequest,
	removeUploadFileExecution,
	SubscriptionTypes,
	PermanentCertificateTypes,
	StepRegisterInputData,
} from '@store';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ProcessFlowState, getProcessFlow } from '@shared/processFlow';
import { DropdownProps, DropdownItemProps } from 'semantic-ui-react';
import { EnrollmentTypes } from '@api/ff-shared-services-api';
import { FileUploadConfig } from '@config';

export interface EntityDataType {
	nipc: string;
	entityName: string;
	address: string;
	postalCodePrefix: string;
	postalCodeSuffix: string;
	locality: string;
	preferredContactName: string;
	preferredContactEmail: string;
	preferredContactPhonePrefix: string;
	preferredContactPhoneNumber: string;
	subscription?: SubscriptionTypes;
	typePermanentCertificate?: PermanentCertificateTypes;
	permanentCertificateFile: FileUploadType;
	permanentCertificateCode: string;
}

interface EntityDataState {
	subscription?: SubscriptionTypes;
	isPrivateNipc: boolean;
	stateKey: string;
	stateUpdatedByFileField: boolean;
}

interface EntityDataInnerProps {
	saveTransferInputData: (registerInputData: RegisterInputData, stepIndex: number) => void;
	fetchUploadFileExecutionRequest: (fileData: FileUploadType) => void;
	removeUploadFileExecution: (currentStep: number) => void;
	modalOpen: (modal: Modal) => void;
	entityData: RegisterInputData;
	processFlow: ProcessFlowState;
}

interface EntityDataFlowProps {
	onClickNext: (data: StepRegisterInputData) => void;
	onClickCancel: () => void;
}

interface EntityDataInjectedProps extends TranslationProps {
	a: Theme;
}

type Props = EntityDataInnerProps & EntityDataInjectedProps & EntityDataFlowProps;

class EntityDataScreenComponent extends React.PureComponent<Props, EntityDataState> {
	// constKey = CoreHelper.guid();
	public constructor(props: Props) {
		super(props);

		const { entityData } = this.props;

		this.state = {
			subscription: entityData.subscription ? entityData.subscription : undefined,
			isPrivateNipc: entityData.nipc ? checkIfIsPrivateNipc(entityData.nipc) : false,
			stateKey: CoreHelper.guid(),
			stateUpdatedByFileField: false,
		};

		window.scrollTo(0, 0);
	}

	componentDidUpdate(prevProps: Props): void {
		const { entityData } = this.props;
		const { stateUpdatedByFileField } = this.state;
		// debugger;
		if (prevProps.entityData !== entityData && stateUpdatedByFileField === false) {
			this.setState({
				stateKey: CoreHelper.guid(),
				subscription: entityData.subscription ? entityData.subscription : undefined,
				isPrivateNipc: entityData.nipc ? checkIfIsPrivateNipc(entityData.nipc) : false,
			});

			// this.constKey = CoreHelper.guid();
		}
	}

	private handleFileChange = (
		file: TemporaryFile,
		action: FileAction,
		currentFile: FileUploadType,
		fieldName: string,
		setFormikInputValue: (field: string, value: FileUploadType, shouldValidate?: boolean) => void
	): void => {
		if (action === FileAction.Add) {
			if (!file.error) {
				const { fetchUploadFileExecutionRequest } = this.props;

				currentFile = {
					id: file.id,
					name: file.file.name,
					type: file.file.type,
					base64File: file.base64File,
					inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CERT_PERM_DOC.toString(),
				};

				const { type, base64File } = currentFile;
				if (type && base64File) {
					fetchUploadFileExecutionRequest(currentFile);
				}
			}
		} else if (action === FileAction.Remove) {
			currentFile = {
				id: '',
				name: '',
				type: '',
				base64File: '',
			};
		}

		setFormikInputValue(fieldName, currentFile, false);
	};

	// eslint-disable-next-line sonarjs/cognitive-complexity
	public render(): JSX.Element {
		const { onClickNext, saveTransferInputData, entityData, t, onClickCancel, modalOpen } = this.props;
		const { subscription, isPrivateNipc, stateKey } = this.state;

		const list: DropdownItemProps[] = [
			{
				key: PermanentCertificateTypes.file,
				value: PermanentCertificateTypes.file,
				text: t('inputs.selectField.file'),
			},
			{
				key: PermanentCertificateTypes.code,
				value: PermanentCertificateTypes.code,
				text: t('inputs.selectField.code'),
			},
		];

		const storeCurrentRegisterFile = entityData.proofInputFile ? entityData.proofInputFile : null;

		return (
			<React.Fragment key={stateKey}>
				<PageScreen name="page-entity-data">
					<p className="ds-heading2-light screen-inner-space">{t('titleContainer.entityData.entityData')}</p>
					<Formik
						validationSchema={entityDataSchema({ t })}
						initialValues={{
							nipc: entityData.nipc ? entityData.nipc : '',
							entityName: entityData.entityName ? entityData.entityName : '',
							address: entityData.address ? entityData.address : '',
							postalCodePrefix: entityData.postalCodePrefix ? entityData.postalCodePrefix : '',
							postalCodeSuffix: entityData.postalCodeSuffix ? entityData.postalCodeSuffix : '',
							locality: entityData.locality ? entityData.locality : '',
							preferredContactName: entityData.preferredContactName
								? entityData.preferredContactName
								: '',
							preferredContactEmail: entityData.preferredContactEmail
								? entityData.preferredContactEmail
								: '',
							preferredContactPhonePrefix: entityData.preferredContactPhonePrefix
								? entityData.preferredContactPhonePrefix
								: '+351',
							preferredContactPhoneNumber: entityData.preferredContactPhoneNumber
								? entityData.preferredContactPhoneNumber
								: '',
							subscription: entityData.subscription ? entityData.subscription : undefined,
							// signaturesNumber: entityData.signaturesNumber ? entityData.signaturesNumber : 1,
							typePermanentCertificate: entityData.typePermanentCertificate
								? entityData.typePermanentCertificate
								: undefined,
							permanentCertificateFile: {
								id: '',
								name: entityData && storeCurrentRegisterFile ? storeCurrentRegisterFile.fileName : '',
								type: '',
								base64File: '',
								currentFlowStepIndex: undefined,
							},
							permanentCertificateCode: entityData.permanentCertificateCode
								? entityData.permanentCertificateCode
								: '',
						}}
						onSubmit={async (values: EntityDataType, { setSubmitting }): Promise<any> => {
							const {
								nipc,
								entityName,
								address,
								postalCodePrefix,
								postalCodeSuffix,
								locality,
								preferredContactName,
								preferredContactEmail,
								preferredContactPhonePrefix,
								preferredContactPhoneNumber,
								typePermanentCertificate,
								subscription,
								permanentCertificateCode,
							} = values;

							const stepInputData: StepRegisterInputData = {
								stepIndex: 1,
								registerInputData: {
									nipc,
									entityName,
									address,
									postalCodePrefix,
									postalCodeSuffix,
									locality,
									preferredContactName,
									preferredContactEmail,
									preferredContactPhonePrefix,
									preferredContactPhoneNumber,
									subscription,
									typePermanentCertificate,
									permanentCertificateCode,
								},
							};

							/* MOCK_DATA - START */
							// const stepInputData: RegisterInputData = {
							// 	nipc: '506985512',
							// 	entityName: 'Nelson',
							// 	address: 'Rua dos dfdf - N°15 - fdffd',
							// 	postalCodePrefix: '3040',
							// 	postalCodeSuffix: '778',
							// 	locality: 'Braga',
							// 	preferredContactName: 'Nelson Barbosa',
							// 	preferredContactEmail: 'dfdfdfdf@hotmail.com',
							// 	preferredContactPhonePrefix: '+351',
							// 	preferredContactPhoneNumber: '9184256119',
							// 	subscription: 'oneSubscription',
							// 	typePermanentCertificate: 'code',
							// 	permanentCertificateCode: '123456789',
							// };
							/* MOCK_DATA - END */

							saveTransferInputData &&
								saveTransferInputData(stepInputData.registerInputData as RegisterInputData, 1);
							setSubmitting(false);
							onClickNext(stepInputData);
						}}
					>
						{({ isSubmitting, setFieldValue, handleChange, values, getFieldMeta }): FormikValues => (
							<Form>
								{/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
								<FieldsFormContainer>
									<TitleContainer2 text={t('titleContainer.entityData.generalData')}>
										<div className="custom-widths screen-inner-space">
											<Field
												component={InputField}
												inputType="text"
												name="nipc"
												defaultValue={entityData.nipc}
												inputFieldLabel={t('label.nipc')}
												isRequired
												hasError={getFieldMeta('nipc').error}
												errorMessage={getFieldMeta('nipc').error}
												onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
													setFieldValue('nipc', e.target.value, false);
													handleChange((values.nipc = e.target.value));
													if (e.target.value && e.target.value.length > 0) {
														const firstChar: string = e.target.value[0];
														this.setState({
															isPrivateNipc: checkIfIsPrivateNipc(firstChar),
														});
													} else {
														this.setState({
															isPrivateNipc: false,
														});
													}
												}}
											/>
											<Field
												component={InputField}
												inputType="text"
												name="entityName"
												defaultValue={entityData.entityName}
												isRequired
												inputFieldLabel={t('label.entityName')}
												hasError={getFieldMeta('entityName').error}
												errorMessage={getFieldMeta('entityName').error}
												onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
													setFieldValue('entityName', e.target.value, false);
													handleChange((values.entityName = e.target.value));
												}}
											/>
											<Field
												component={InputField}
												inputType="text"
												name="address"
												defaultValue={entityData.address}
												isRequired
												inputFieldLabel={t('label.address')}
												hasError={getFieldMeta('address').error}
												errorMessage={getFieldMeta('address').error}
												onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
													setFieldValue('address', e.target.value, false);
													handleChange((values.address = e.target.value));
												}}
											/>
											<div
												className="flex-inline children-width-auto"
												style={{ alignItems: 'flex-end' }}
											>
												{/* <div className="inputs-top"> */}
												<Field
													component={InputField}
													inputType="text"
													name="postalCodePrefix"
													defaultValue={entityData.postalCodePrefix}
													isRequired
													maxLength={4}
													inputFieldLabel={t('label.postalCode')}
													hasError={getFieldMeta('postalCodePrefix').error}
													errorMessage={getFieldMeta('postalCodePrefix').error}
													onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
														setFieldValue('postalCodePrefix', e.target.value, false);
														handleChange((values.postalCodePrefix = e.target.value));
													}}
												/>

												<Field
													component={InputField}
													inputType="text"
													name="postalCodeSuffix"
													defaultValue={entityData.postalCodeSuffix}
													maxLength={3}
													inputFieldLabel=""
													hasError={getFieldMeta('postalCodeSuffix').error}
													errorMessage={getFieldMeta('postalCodeSuffix').error}
													onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
														setFieldValue('postalCodeSuffix', e.target.value, false);
														handleChange((values.postalCodeSuffix = e.target.value));
													}}
												/>
												{/* </div> */}

												{/* <div className="inputs-bottom"> */}
												<Field
													component={InputField}
													inputType="text"
													name="locality"
													isRequired
													defaultValue={entityData.locality}
													inputFieldLabel={t('label.locality')}
													hasError={getFieldMeta('locality').error}
													errorMessage={getFieldMeta('locality').error}
													onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
														setFieldValue('locality', e.target.value, false);
														handleChange((values.locality = e.target.value));
													}}
												/>
												{/* </div> */}
											</div>
										</div>
									</TitleContainer2>
									<TitleContainer2 text={t('titleContainer.entityData.preferredContact')}>
										<p className="descriptions">{t('descriptions.entityData.preferredContact')}</p>
										<div className="custom-widths2 screen-inner-space">
											<Field
												component={InputField}
												inputType="text"
												name="preferredContactName"
												isRequired
												defaultValue={entityData.preferredContactName}
												inputFieldLabel={t('label.name')}
												hasError={getFieldMeta('preferredContactName').error}
												errorMessage={getFieldMeta('preferredContactName').error}
												onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
													setFieldValue('preferredContactName', e.target.value, false);
													handleChange((values.preferredContactName = e.target.value));
												}}
											/>
											<Field
												component={InputField}
												inputType="text"
												name="preferredContactEmail"
												isRequired
												defaultValue={entityData.preferredContactEmail}
												inputFieldLabel={t('label.email')}
												hasError={getFieldMeta('preferredContactEmail').error}
												errorMessage={getFieldMeta('preferredContactEmail').error}
												onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
													setFieldValue('preferredContactEmail', e.target.value, false);
													handleChange((values.preferredContactEmail = e.target.value));
												}}
											/>
											<div
												className="flex-inline children-width-auto"
												style={{ alignItems: 'flex-end' }}
											>
												<div style={{ marginRight: '0.5rem' }}>
													<Field
														component={InputField}
														inputType="text"
														name="preferredContactPhonePrefix"
														defaultValue={
															entityData.preferredContactPhonePrefix === ''
																? '+351'
																: entityData.preferredContactPhonePrefix
														}
														inputFieldLabel={t('label.phone')}
														isRequired
														hasError={getFieldMeta('preferredContactPhonePrefix').error}
														errorMessage={getFieldMeta('preferredContactPhonePrefix').error}
														onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
															setFieldValue(
																'preferredContactPhonePrefix',
																e.target.value,
																false
															);
															handleChange(
																(values.preferredContactPhonePrefix = e.target.value)
															);
														}}
													/>
												</div>
												<Field
													component={InputField}
													inputType="text"
													name="preferredContactPhoneNumber"
													defaultValue={entityData.preferredContactPhoneNumber}
													// inputFieldLabel={t('label.phone')}
													// isRequired
													hasError={getFieldMeta('preferredContactPhoneNumber').error}
													errorMessage={getFieldMeta('preferredContactPhoneNumber').error}
													onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
														setFieldValue(
															'preferredContactPhoneNumber',
															e.target.value,
															false
														);

														handleChange(
															(values.preferredContactPhoneNumber = e.target.value)
														);
													}}
												/>
											</div>
										</div>
									</TitleContainer2>
									<TitleContainer2 text={t('titleContainer.entityData.entityDocumentation')}>
										<p className="descriptions">
											{t('descriptions.entityData.entityDocumentation')}
										</p>
										<div className="custom-widths3 screen-inner-space">
											<div className="radios-inline-step1 screen-inner-space">
												<Field
													component={RadioButton}
													id={CoreHelper.guid()}
													name="subscription"
													value={SubscriptionTypes.oneSubscription}
													labelText={t('radioButton.oneSubscription')}
													isChecked={
														subscription === SubscriptionTypes.oneSubscription
															? true
															: false
													}
													hasError={getFieldMeta('subscription').error}
													errorMessage={getFieldMeta('subscription').error}
													onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
														this.setState({
															subscription: SubscriptionTypes[e.target.value],
														});
														setFieldValue(
															'subscription',
															SubscriptionTypes[e.target.value],
															false
														);
														// handleChange(
														// 	(values.subscription =
														// 		SubscriptionTypes[e.target.value])
														// );
													}}
												/>
												<div style={{ width: '2.5rem' }} />
												<Field
													component={RadioButton}
													id={CoreHelper.guid()}
													name="subscription"
													value={SubscriptionTypes.moreThanOneSubscription}
													labelText={t('radioButton.moreThanOneSubscription')}
													isChecked={
														subscription === SubscriptionTypes.moreThanOneSubscription
															? true
															: false
													}
													onChange={(
														e: React.ChangeEvent<HTMLInputElement>
														// eslint-disable-next-line sonarjs/no-identical-functions
													): void => {
														this.setState({
															subscription: SubscriptionTypes[e.target.value],
														});
														setFieldValue(
															'subscription',
															SubscriptionTypes[e.target.value],
															false
														);
														// handleChange(
														// 	(values.subscription =
														// 		SubscriptionTypes[e.target.value])
														// );
													}}
												/>
											</div>

											{!isPrivateNipc ? (
												<Field
													component={SelectField}
													options={list}
													placeholder={t('inputs.selectField.selectOneOption')}
													isRequired
													defaultValue={entityData.typePermanentCertificate}
													hasError={getFieldMeta('typePermanentCertificate').error}
													errorMessage={getFieldMeta('typePermanentCertificate').error}
													selectFieldLabel={t('label.entityData.permanentCertificate')}
													onChange={(
														event: React.SyntheticEvent<HTMLElement>,
														data: DropdownProps
													): void => {
														setFieldValue('typePermanentCertificate', data.value, false);
													}}
												/>
											) : (
												''
											)}

											{isPrivateNipc ||
											values.typePermanentCertificate === PermanentCertificateTypes.file ? (
												<div style={{ paddingBottom: '0.1rem' }}>
													<Field
														component={FileField}
														name="permanentCertificateFile"
														isRequired
														buttonText={t('buttons.general.select')}
														fileFieldLabel={
															isPrivateNipc
																? 'Comprovativo de Morada'
																: t('label.entityData.permanentCertificateFile')
														}
														nrAllowedFiles={1}
														showAttachmentsNumberInfoModal={(text: string): void => {
															modalOpen(
																BuildOkInfoModal(t(text, { maxNumber: 1 }), 'Ok')
															);
														}}
														filesMaxSize={FileUploadConfig.maxFileSizeBytes}
														showAttachmentSizeInfoModal={(text: string): void => {
															modalOpen(
																BuildOkInfoModal(
																	t(text, {
																		maxSize: FileUploadConfig.maxFileSizeMegaBytes,
																	}),
																	'Ok'
																)
															);
														}}
														filesList={
															entityData && storeCurrentRegisterFile
																? [
																		{
																			id: storeCurrentRegisterFile.id
																				? storeCurrentRegisterFile.id
																				: '',
																			name: storeCurrentRegisterFile.fileName,
																		},
																  ]
																: undefined
														}
														// isDownloadable={
														// 	storeCurrentRegisterFile &&
														// 	storeCurrentRegisterFile.isDownloadable
														// }
														// downloadFile={(id: string): void => {
														// 	storeCurrentRegisterFile &&
														// 		this.downloadDocument(storeCurrentRegisterFile.id);
														// }}
														handleFile={(file: TemporaryFile, action: FileAction): void => {
															this.setState({ stateUpdatedByFileField: true });
															this.handleFileChange(
																file,
																action,
																values.permanentCertificateFile,
																'permanentCertificateFile',
																setFieldValue
															);

															// this.setState({
															// 	proofInputFile: {
															// 		id: file ? file.id : '',
															// 		fileName: file ? file.file : '',
															// 		// inputType:
															// 		// 	EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
															// 		isDownloadable: false,
															// 	},
															// });
														}}
														hasError={getFieldMeta('permanentCertificateFile').error}
														errorMessage={t('errors.form.required')}
													/>
												</div>
											) : (
												''
											)}
											{!isPrivateNipc &&
											values.typePermanentCertificate === PermanentCertificateTypes.code ? (
												<Field
													component={InputField}
													inputType="text"
													name="permanentCertificateCode"
													isRequired
													defaultValue={entityData.permanentCertificateCode}
													inputFieldLabel={t('label.entityData.permanentCertificateCode')}
													hasError={getFieldMeta('permanentCertificateCode').error}
													errorMessage={getFieldMeta('permanentCertificateCode').error}
													onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
														setFieldValue(
															'permanentCertificateCode',
															e.target.value,
															false
														);
														handleChange(
															(values.permanentCertificateCode = e.target.value)
														);
													}}
												/>
											) : (
												''
											)}
										</div>
									</TitleContainer2>

									<div className="bottom-buttons screen-inner-space">
										<Button primary text={t('general.button.continue')} type="submit" />

										<Button
											tertiary
											text={t('general.button.cancel')}
											onClick={event => {
												event.preventDefault();
												onClickCancel();
											}}
											// onClick={onClickCancel}
										/>
									</div>
								</FieldsFormContainer>
							</Form>
						)}
					</Formik>
					{/* </div>
			</div> */}
				</PageScreen>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState): object => ({
	entityData: getRegisterPharmacyInputData(state),
	processFlow: getProcessFlow(state),
});
const mapDispatchToProps = (dispatch: any): object =>
	bindActionCreators(
		{ saveTransferInputData, fetchUploadFileExecutionRequest, removeUploadFileExecution, modalOpen },
		dispatch
	);

export default WithCoreProps<EntityDataFlowProps>(
	connect(mapStateToProps, mapDispatchToProps)(EntityDataScreenComponent)
);
